import React, { useState } from "react";
import { connect } from "react-redux";
import List from "./List";
import Create from "./Create";

import { Layout, Breadcrumb, Row, Col } from "antd";
const { Content } = Layout;

const Attribute = () => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <Layout className="window-frame">
        <Layout className="site-layout">
          <Content className="main-frame-content">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Tags</Breadcrumb.Item>
              <Breadcrumb.Item>All</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
              <Row>
                <Col span={24}>
                  <Create
                    setUpdatelist={setUpdatelist}
                    updatelist={updatelist}
                  />
                  <h3>Tags</h3>
                  <List updatelist={updatelist} setUpdatelist={setUpdatelist} />
                </Col>
              </Row>
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default connect()(Attribute);
